import { styled } from "themes"

export const RelatedArticlesWrapper = styled.section`
  padding: 40px 0;
  background: #f6f7fa;
  margin-top: -50px;
`
